export const getLayerPositionX = (layer, custom = {}) => {
  const positionX = custom.position_x ?? layer.position_x;
  const width = custom.width ?? layer.width;

  if (layer.type !== "text" || layer.stay_centered === false || custom.width === undefined) {
    return positionX;
  }

  return layer.position_x + ((layer.width - width) / 2);
};
